<template>
    <div style="height: 100%;width: 100%;display: flex;">
        <!--页面一左列 题目列表-->
        <div class="ex-sidebar">
            <div class="ex-sidebar-title">{{ exam.name || '练习' }}</div>
            <div class="ex-sidebar-scroll">
                <div v-for="(p,i) in exam.questions" :key="'p-'+i" class="ex-question-item"
                    :class="{ active: i == questionId, answered: map.has(p.id) }"
                    @click="loadQuestion(p,i)">
                    <span class="ex-q-num">{{ i + 1 }}</span>
                    <span class="ex-q-status">{{ map.has(p.id) ? '✓' : '' }}</span>
                </div>
            </div>
        </div>
        <!--页面一中间 题目内容（含选项等）-->
        <div class="ex-content">
            <!-- 题目头部信息 -->
            <div class="ex-q-header">
                <span :class="['ex-diff-badge', 'diff-' + (question.level == 1 ? 'easy' : question.level == 2 ? 'mid' : 'hard')]">
                    {{ question.level == 1 ? '简单' : question.level == 2 ? '中等' : '困难' }}
                </span>
                <span class="ex-q-tag" v-if="question && question.tags && question.tags.length > 0">
                    <span v-for="(t,k) in question.tags" :key="'t-'+k" class="tag-label">{{ t.name }}</span>
                </span>
            </div>

            <!-- 当前题目已选择答案的展示区 -->
            <div class="ex-choice-display" v-if="optionId >= 0 && question.options && question.options[optionId]">
                <div class="choice-letter">{{ ['A','B','C','D'][optionId] || optionId }}</div>
                <div class="choice-text">{{ question.options[optionId] }}</div>
            </div>

            <!-- 题干 -->
            <div class="ex-question-body" v-html="renderQuestion(question)"></div>

            <!-- 图片 -->
            <div class="ex-q-image" v-if="question && question.picture" v-bind:style="{ backgroundImage: 'url(' + question.picture + ')' }"></div>

            <!-- 代码 -->
            <div class="ex-code-block" v-if="question && question.code" v-html="renderQuestionCode(question.code)"></div>
        </div>
        <!--页面一右列 选项图文-->
        <div class="ex-operation">
            <!-- 操作按钮 -->
            <div class="ex-action-row">
                <button :class="['ex-nav-btn', 'nav-prev']" @click="prevQuestion" :disabled="questionId == 0">上一题</button>
                <button :class="['ex-nav-btn', 'nav-next']" @click="nextQuestion"
                    :disabled="questionId == (exam.questions ? exam.questions.length - 1 : 0)">下一题</button>
                <div class="ex-q-index">
                    <span class="index-current">{{ questionId + 1 }}</span>
                    <span class="index-sep">/</span>
                    <span class="index-total">{{ exam.questions ? exam.questions.length : 0 }}</span>
                </div>
            </div>

            <!-- 选项区 -->
            <div class="ex-options-scroll">
                <div v-for="(o,i) in question.options" :key="'o-'+i" class="ex-option-card"
                    :class="{ selected: optionId == i }" @click="setAnswer(question.id, i)">
                    <div class="option-letter">{{ ['A','B','C','D'][i] || i }}</div>
                    <div class="option-text">{{ o }}</div>
                    <div class="option-check" v-if="optionId == i">✓</div>
                </div>
            </div>

            <!-- 解析按钮 -->
            <div class="ex-footer-action">
                <button class="btn-analysis" @click="openDrawer" v-if="!map.has(question.id)">
                    提交并查看解析
                </button>
                <button class="btn-analysis show" @click="openDrawer" v-if="map.has(question.id)">
                    查看解析
                </button>
                <!--收藏按钮-->
                <div class="ex-fav-btns">
                    <span v-if="!favorite.includes(question.id)" @click="addTofav(question.id)" class="fav-btn">
                        ♡ 收藏
                    </span>
                    <span v-if="favorite.includes(question.id)" @click="cancelFav(question.id)" class="fav-btn favorited">
                        ♥ 已收藏
                    </span>
                </div>
            </div>
        </div>

        <!-- 解析侧边抽屉 -->
        <div id="drawer" class="drawer-overlay">
            <div class="drawer-panel">
                <div class="drawer-header">
                    <span class="drawer-title">题目解析</span>
                    <button class="drawer-close" @click="closeDrawer">✕</button>
                </div>
                <div class="drawer-body">
                    <div class="drawer-section">
                        <div class="drawer-label">正确答案</div>
                        <div class="drawer-value correct-answer">{{ question.answer }}</div>
                    </div>
                    <div class="drawer-section">
                        <div class="drawer-label">解析</div>
                        <div class="drawer-text" v-html="renderQuestion(question.analysis)"></div>
                    </div>
                </div>
            </div>
        </div>
        <div id="overlay" class="drawer-backdrop" @click="closeDrawer"></div>
    </div>
</template>

<script>
import axios from 'axios';
import util from '@/utils/util';
export default {
    data() {
        return {
            question: {},
            questionId: 0,
            optionId: -1,
            map: new Map(),
            exam: {},
            favorite: [],
            userInfo: {},
            saveTimer: null,
            exerciseKey: '',
        };
    },
    mounted() {
        var token = localStorage.getItem("token");
        if (token == null) {
            // alert("请先登录");
            // return;
        } else {
            var info = JSON.parse(window.atob(token));
            this.userInfo = { UserId: "1", Token: token };
        }

        this.loadFav();

        var id = util.getSearchString("id");
        var tagId = util.getSearchString("tag") || '';
        this.exerciseKey = id + '_' + tagId;

        if (id == 1) {
            //每日练习
            axios.get('https://apapi.dctechonline.cn/api/daily/unlimited/10').then(response => {
                var obj = {};
                obj.name = '每日练习';
                obj.questions = response.data;
                this.exam = obj;
                this.restoreFromStorage();
                this.loadQuestion(this.exam.questions[this.questionId], this.questionId);
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        }
        else if (id == 2) {
            //收藏反复练
            axios.get('https://apapi.dctechonline.cn/api/favorite/' + this.userInfo.UserId + '/0').then(response => {
                var obj = {};
                obj.name = '收藏反复练';
                obj.questions = response.data;
                this.exam = obj;
                this.restoreFromStorage();
                this.loadQuestion(this.exam.questions[this.questionId], this.questionId);
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        }
        else if (id == 3) {
            //专项练习
            var tagId = util.getSearchString("tag");
            axios.get(`https://apapi.dctechonline.cn/api/tag/${tagId}/0`).then(response => {
                var obj = {};
                obj.name = '专项练习';
                obj.questions = response.data;
                this.exam = obj;
                this.restoreFromStorage();
                this.loadQuestion(this.exam.questions[this.questionId], this.questionId);
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        }
    },
    methods: {
        renderQuestion(text) {
            if (text && text.indexOf('[IMG]') > -1) {
                var url = text.substring(text.indexOf('[IMG]') + 5, text.indexOf('[/IMG]'));
                return text.replace('[IMG]' + url + '[/IMG]', '<img src=\"' + url + '\"/>');
            }

            return text;
        },
        loadFav() {
            axios.get('https://apapi.dctechonline.cn/api/favorite/' + this.userInfo.UserId).then(response => {
                this.favorite = response.data;
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        addTofav(qid) {
            var postInfo = { UserId: this.userInfo.UserId, QuestionId: qid };
            this.$http.post('https://apapi.dctechonline.cn/api/favorite/', postInfo).then(response => {
                this.loadFav();
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        cancelFav(qid) {
            this.$http.delete('https://apapi.dctechonline.cn/api/favorite/' + qid).then(response => {
                this.loadFav();
                if (this.exam.name == '收藏反复练') {
                    this.exam.questions = this.exam.questions.filter(function (item) {
                        return item.id != qid;
                    });
                    if (this.exam.questions.length > 0) {
                        this.loadQuestion(this.exam.questions[0], 0);
                    }
                }
            }).catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        renderQuestionCode(text) {
            if (text) {
                return '<pre>' + text + '</pre>';
            }
            return '';
        },
        setAnswer(id, a) {
            this.map.set(id, a);
            this.optionId = a;
            this.question = { ...this.question };
            this.saveToStorage();
        },
        loadQuestion(q, index) {
            axios.get(`https://apapi.dctechonline.cn/api/question/${q.id}`).then((response) => {
                this.question = response.data;
                this.questionId = index;
                if (this.map.has(this.exam.questions[this.questionId].id)) {
                    this.optionId = this.map.get(this.exam.questions[this.questionId].id);
                } else {
                    this.optionId = -1;
                }
                this.saveToStorage();
            });
        },
        prevQuestion() {
            if (this.questionId > 0) {
                this.loadQuestion(this.exam.questions[this.questionId - 1], this.questionId - 1);
            }
        },
        nextQuestion() {
            if (this.questionId < this.exam.questions.length - 1) {
                this.loadQuestion(this.exam.questions[this.questionId + 1], this.questionId + 1);
            }
        },
        openDrawer() {
            document.getElementById('drawer').classList.add('open');
            document.getElementById('overlay').classList.add('open');
        },
        saveToStorage() {
            if (!this.exerciseKey) return;
            if (this.saveTimer) clearTimeout(this.saveTimer);
            this.saveTimer = setTimeout(() => {
                const mapArr = Array.from(this.map.entries());
                localStorage.setItem('exercise_map_' + this.exerciseKey, JSON.stringify(mapArr));
                localStorage.setItem('exercise_question_' + this.exerciseKey, this.questionId);
            }, 300);
        },
        restoreFromStorage() {
            if (!this.exerciseKey) return;
            try {
                const savedMap = localStorage.getItem('exercise_map_' + this.exerciseKey);
                if (savedMap) {
                    const arr = JSON.parse(savedMap);
                    this.map = new Map(arr);
                }
                const savedQ = localStorage.getItem('exercise_question_' + this.exerciseKey);
                if (savedQ !== null) {
                    const qid = parseInt(savedQ);
                    if (qid >= 0 && qid < this.exam.questions.length) {
                        this.questionId = qid;
                    }
                }
            } catch (e) {
                // 解析失败则忽略
            }
        },
        closeDrawer() {
            document.getElementById('drawer').classList.remove('open');
            document.getElementById('overlay').classList.remove('open');
        },
    },
}
</script>

<style lang="scss" scoped>
// ========================
// 左侧题目列表
// ========================
.ex-sidebar {
    width: 72px;
    min-width: 72px;
    background: #1e293b;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

.ex-sidebar-title {
    padding: 14px 8px;
    font-size: 12px;
    font-weight: 600;
    color: #94a3b8;
    text-align: center;
    border-bottom: 1px solid #334155;
    white-space: nowrap;
    flex-shrink: 0;
}

.ex-sidebar-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.ex-question-item {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-sm);
    cursor: pointer;
    position: relative;
    transition: all var(--transition-fast);
    background: rgba(255, 255, 255, 0.04);

    .ex-q-num {
        font-size: 13px;
        font-weight: 600;
        color: #94a3b8;
        transition: color var(--transition-fast);
    }

    .ex-q-status {
        position: absolute;
        bottom: 2px;
        right: 4px;
        font-size: 10px;
        color: var(--color-success);
        font-weight: 700;
    }

    &:hover {
        background: rgba(255, 255, 255, 0.08);

        .ex-q-num {
            color: #e2e8f0;
        }
    }

    &.active {
        background: var(--color-primary);
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.4);

        .ex-q-num {
            color: #fff;
        }

        .ex-q-status {
            color: #fff;
        }
    }

    &.answered {
        .ex-q-num {
            color: #86efac;
        }

        &.active .ex-q-num {
            color: #fff;
        }
    }
}

// ========================
// 中间题目内容区
// ========================
.ex-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background: var(--bg-page);
    padding: 24px 28px;
    gap: 18px;
}

.ex-q-header {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.ex-diff-badge {
    padding: 3px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;

    &.diff-easy {
        background: #d1fae5;
        color: #065f46;
    }

    &.diff-mid {
        background: #fef3c7;
        color: #92400e;
    }

    &.diff-hard {
        background: #fee2e2;
        color: #991b1b;
    }
}

.tag-label {
    display: inline-block;
    padding: 2px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
    background: #e0e7ff;
    color: #3730a3;
    margin-right: 6px;
}

// 已选答案展示
.ex-choice-display {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: var(--color-primary-light);
    border: 1px solid #bfdbfe;
    border-radius: var(--radius-md);
    animation: fadeIn 0.3s ease;
}

.choice-letter {
    width: 32px;
    height: 32px;
    border-radius: var(--radius-sm);
    background: var(--color-primary);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    flex-shrink: 0;
}

.choice-text {
    font-size: 15px;
    font-weight: 500;
    color: #1e3a5f;
}

// 题干
.ex-question-body {
    font-size: 16px;
    line-height: 1.8;
    color: var(--text-primary);
    background: var(--bg-surface);
    padding: 24px;
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-color);

    ::v-deep img {
        max-width: 100%;
        border-radius: var(--radius-sm);
    }
}

// 图片
.ex-q-image {
    width: 100%;
    height: 200px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-color);
}

// 代码块
.ex-code-block {
    background: #1e1e1e;
    border-radius: var(--radius-md);
    padding: 20px;
    overflow-x: auto;

    ::v-deep pre {
        margin: 0;
        color: #d4d4d4;
        font-family: 'Fira Code', 'Consolas', monospace;
        font-size: 14px;
        line-height: 1.6;
        white-space: pre-wrap;
        word-break: break-all;
    }
}

// ========================
// 右侧选项区
// ========================
.ex-operation {
    width: 320px;
    min-width: 320px;
    background: var(--bg-surface);
    display: flex;
    flex-direction: column;
    border-left: 1px solid var(--border-color);
    height: 100%;
}

.ex-action-row {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    gap: 8px;
    border-bottom: 1px solid var(--border-color);
    flex-shrink: 0;
}

.ex-nav-btn {
    padding: 6px 14px;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
    background: var(--bg-surface);
    color: var(--text-secondary);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);

    &:hover:not(:disabled) {
        background: var(--bg-surface-hover);
        border-color: #cbd5e1;
        color: var(--text-primary);
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }
}

.ex-q-index {
    margin-left: auto;
    font-size: 14px;
    color: var(--text-muted);

    .index-current {
        font-size: 20px;
        font-weight: 700;
        color: var(--color-primary);
    }

    .index-sep {
        margin: 0 2px;
    }

    .index-total {
        font-size: 14px;
    }
}

// 选项列表
.ex-options-scroll {
    flex: 1;
    overflow-y: auto;
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ex-option-card {
    display: flex;
    align-items: flex-start;
    padding: 14px 16px;
    border: 2px solid var(--border-color);
    border-radius: var(--radius-md);
    cursor: pointer;
    transition: all var(--transition-fast);
    background: var(--bg-surface);
    gap: 12px;

    &:hover {
        border-color: #93c5fd;
        background: #f8faff;
        transform: translateX(2px);
    }

    &.selected {
        border-color: var(--color-primary);
        background: var(--color-primary-light);

        .option-letter {
            background: var(--color-primary);
            color: #fff;
        }

        .option-text {
            color: #1e3a5f;
        }
    }
}

.option-letter {
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: var(--radius-sm);
    background: var(--bg-page);
    color: var(--text-muted);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    transition: all var(--transition-fast);
}

.option-text {
    flex: 1;
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-secondary);
    transition: color var(--transition-fast);
}

.option-check {
    font-size: 18px;
    color: var(--color-primary);
    font-weight: 700;
}

// 底部：解析和收藏
.ex-footer-action {
    padding: 14px 16px;
    border-top: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.btn-analysis {
    padding: 10px 24px;
    border: none;
    border-radius: var(--radius-sm);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all var(--transition-fast);
    background: var(--color-primary);
    color: #fff;

    &:hover {
        background: var(--color-primary-hover);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }

    &.show {
        background: var(--bg-surface);
        border: 2px solid var(--color-primary);
        color: var(--color-primary);

        &:hover {
            background: var(--color-primary-light);
        }
    }
}

.ex-fav-btns {
    display: flex;
    gap: 8px;
}

.fav-btn {
    padding: 8px 14px;
    border-radius: var(--radius-sm);
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: all var(--transition-fast);
    border: 1px solid var(--border-color);
    color: var(--text-muted);
    background: transparent;
    user-select: none;

    &:hover {
        color: #ef4444;
        border-color: #fecaca;
        background: #fef2f2;
    }

    &.favorited {
        color: #ef4444;
        border-color: #fecaca;
        background: #fef2f2;
    }
}

// ========================
// 解析抽屉
// ========================
.drawer-overlay {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 420px;
    background: var(--bg-surface);
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.12);
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 200;
    display: flex;
    flex-direction: column;

    &.open {
        transform: translateX(0);
    }
}

.drawer-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    z-index: 199;

    &.open {
        opacity: 1;
        pointer-events: auto;
    }
}

.drawer-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    border-bottom: 1px solid var(--border-color);
    flex-shrink: 0;
}

.drawer-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.drawer-close {
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    font-size: 18px;
    color: var(--text-muted);
    cursor: pointer;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all var(--transition-fast);

    &:hover {
        background: #fee2e2;
        color: var(--color-danger);
    }
}

.drawer-body {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
}

.drawer-section {
    margin-bottom: 24px;
}

.drawer-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--text-muted);
    margin-bottom: 8px;
}

.correct-answer {
    font-size: 24px;
    font-weight: 800;
    color: var(--color-success);
    padding: 12px 16px;
    background: #d1fae5;
    border-radius: var(--radius-md);
    display: inline-block;
}

.drawer-text {
    font-size: 15px;
    line-height: 1.8;
    color: var(--text-primary);
    padding: 16px;
    background: #f8fafc;
    border-radius: var(--radius-md);
}
</style>
